<!-- SPDX-License-Identifier: AGPL-3.0-only -->

<template>
  <div class="product-mark" aria-label="LacunaScope">
    <span class="product-mark__signal" aria-hidden="true">
      <span></span>
      <span></span>
      <span></span>
    </span>
    <span class="product-mark__name">Lacuna<span>Scope</span></span>
  </div>
</template>
